import Image from "_components/atoms/image";

import Avatar          from "./avatar";
import useStyles       from "./styles/smallStickerComment";
import UserNameAndTags from "./usernameAndTags";

const SmallStickerComment = ( { data } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.smallStickerCommentContainer }>
			<Avatar
				photo       = { data.sportsFan.photo }
				sportsFanId = { data.sportsFan.id }
			/>

			<div className = { classes.userNameAndCommentInSmallSticker }>

				<UserNameAndTags
					data = { data }

				/>

				<div>
					<Image
						className = { classes.smallSticker }
						src       = { data.donationProductUrl }
						type      = "mdpi"
					/>
				</div>

			</div>

		</div>
	);

};

export default SmallStickerComment;
